module.exports = __webpack_public_path__ + "img/1585815130.2bedd0aa.jpg";